import { observer } from "mobx-react";
import * as React from "react";
import { dashboardListHeaderOptions } from "../../constants";
import { ApplicationStateEnum } from "../../network/APITypes";
import { TableStore } from "../../stores/TableStore";
import { JobCategoryEnum } from "../../types/models";
import { useApplicants } from "../hooks/useApplicants";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";
import { HrBotApplicantsList } from "../ui/HrBotApplicantsList";

type Props = {
    jobCategories: Array<JobCategoryEnum>;
    tableStore: TableStore;
    applicationStates: Array<ApplicationStateEnum>;
};

export const DashboardList = observer(({ jobCategories, tableStore, applicationStates }: Props) => {
    const isMobile = useMobileMediaQuery();

    const { applicants, initialLoaded } = useApplicants(
        {
            jobCategory: jobCategories,
            applicationState: applicationStates
        },
        tableStore
    );

    const responsiveHeaderOptions = isMobile ? dashboardListHeaderOptions.slice(0, 2) : dashboardListHeaderOptions;

    const tableCellWidthProportionsArray = isMobile ? [1, 1] : [1, 1, 1, 1, 1, 1];

    return (
        <HrBotApplicantsList
            applicants={applicants}
            tableStore={tableStore}
            initialLoaded={initialLoaded}
            responsiveHeaderOptions={responsiveHeaderOptions}
            tableCellWidthProportionsArray={tableCellWidthProportionsArray}
            hideCheckboxes={true}
        />
    );
});
